
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./OilyWaterTank.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";




 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function OilyWaterTank() {

        useEffect(() => {
  
    trackPageVisit("OilyWaterTank");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  FCV_2931: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2932: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("OilyWaterTank_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2931: { ...DEFAULT_VALVES.FCV_FCV_2931, ...parsed.FCV_2931 },
      FCV_2932: { ...DEFAULT_VALVES.FCV_FCV_2932, ...parsed.FCV_2932 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});


 
/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("OilyWaterTank_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  
  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};







  




      const [FIC_2912, setFIC_2912] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2912")) || 0;
            setFIC_2912(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


        const [PT_2912, setPT_2912] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2912")) || 0;
            setPT_2912(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


        
      const [FIC_2921, setFIC_2921] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2921")) || 0;
            setFIC_2921(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


        const [PT_2921, setPT_2921] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2921")) || 0;
            setPT_2921(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

        

        
      const isXV2931Open = valves?.XV_2931 === false;
      const isXV2932Open = valves?.XV_2932 === false;
      const isXV2933Open = valves?.XV_2933 === false;
      const isXV2934Open = valves?.XV_2934 === false;


        const FIC_2933 = FIC_2912 * 0.998;
        const PT_2932 = PT_2912 * 0.998;

        const FIC_2934 = FIC_2921 * 0.998;
        const PT_2933 = PT_2921 * 0.998;

        const FIC_2931 = isXV2934Open ? 6.984 : 0;

        const FIC_2932 = FIC_2931 + FIC_2933 + FIC_2934;


// ================= THRESHOLD =================
const MIN_VALID = 0.03;


// ================= AVAILABILITY CHECK =================
const isPT2932Available = PT_2932 > MIN_VALID;
const isPT2933Available = PT_2933 > MIN_VALID;


// ================= AVERAGING LOGIC =================
let PT_2931 = 0;

if (isPT2932Available && isPT2933Available) {
  // both available → average
  PT_2931 = (PT_2932 + PT_2933) / 2;

} else if (isPT2932Available) {
  // only PT_2932 available
  PT_2931 = PT_2932;

} else if (isPT2933Available) {
  // only PT_2933 available
  PT_2931 = PT_2933;

} else {
  // none available → dead system
  PT_2931 = 0;
}


// ================= CLEAN OUTPUT =================
PT_2931 = Number(PT_2931.toFixed(3));


// ================= SAVE TO GLOBAL TAG =================
useEffect(() => {
  localStorage.setItem("PT_2931", PT_2931);
}, [PT_2931]);


  const PT_2934 = isXV2931Open ? PT_2931 * 0.995 : 0.03;

  const FIC_2935 = isXV2931Open ? FIC_2932 * 0.005 : 0;

  useEffect(() => {
        localStorage.setItem("FIC_2935", FIC_2935);
      }, [FIC_2935]);

  const PT_2935 = PT_2934 * 0.267;


  const PT_2938 = isXV2933Open ? PT_2934 * 0.495 : 0.03;







  // ================= CONTEXT =================
const { pumpData } = useContext(PumpContext);

// ================= PUMP STATUS =================
const isPumpAOn = pumpData?.["P-2930A"]?.running ?? false;
const isPumpBOn = pumpData?.["P-2930B"]?.running ?? false;

const runningPumps = [isPumpAOn, isPumpBOn].filter(Boolean).length;

// ================= VALVE =================
const valveOpening = Math.max(
  0,
  Math.min(100, Number(valveData?.FCV_2932?.opening ?? 0))
);


// ================= SUCTION PRESSURE =================
const suctionPressure = Number(PT_2938 || 0);

// ================= TARGET FLOW =================
let targetFlow = 0;

if (isXV2933Open && runningPumps > 0) {
  targetFlow = 100 * (valveOpening / 100);
} else {
  targetFlow = 0;
}

// ================= TARGET DISCHARGE PRESSURE =================
let targetPressure = 0;

if (!isXV2933Open) {
  // valve closed → dead head condition
  targetPressure = 0.03;

} else if (runningPumps > 0) {
  // pressure depends on suction + valve boost
  targetPressure =
    suctionPressure +
    (6 - suctionPressure) * (valveOpening / 100);

} else {
  targetPressure = 0;
}


// ================= STATES =================
const [FIC_2936, setFIC_2936] = useState(
  Number(localStorage.getItem("FIC_2936")) || 0
);

const [PT_2936, setPT_2936] = useState(
  Number(localStorage.getItem("PT_2936")) || 0.03
);



// ================= SMOOTH RESPONSE =================
useEffect(() => {
  const interval = setInterval(() => {

    // FLOW
    setFIC_2936(prev => {
      const error = targetFlow - prev;

      const gain =
        runningPumps === 2 ? 0.20 :
        runningPumps === 1 ? 0.15 :
        0.10;

      const next = prev + error * gain;

      return Math.abs(next) < 0.05 ? 0 : Number(next.toFixed(2));
    });


    // PRESSURE
    setPT_2936(prev => {
      const error = targetPressure - prev;

      const gain =
        runningPumps === 2 ? 0.22 :
        runningPumps === 1 ? 0.16 :
        0.10;

      const next = prev + error * gain;

      return Number(next.toFixed(3));
    });

  }, 100);

  return () => clearInterval(interval);

}, [targetFlow, targetPressure, runningPumps]);


// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("FIC_2936", FIC_2936);
}, [FIC_2936]);

useEffect(() => {
  localStorage.setItem("PT_2936", PT_2936);
}, [PT_2936]);


// ================= OPTIONAL: LOAD SHARING =================
const flowPerPump =
  runningPumps > 0 ? FIC_2936 / runningPumps : 0;

const pressureContributionPerPump =
  runningPumps > 0 ? PT_2936 / runningPumps : 0;





  const FIC_2937 = isXV2932Open ? 20 * Number(valveData?.FCV_2931?.opening ?? 0)/100 : 0;
  const PT_2937 = isXV2932Open ? PT_2934 * Number(valveData?.FCV_2931?.opening ?? 0)/100 : 0;







     


  return (
    <div className="OilyWaterTank-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "253px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)", 
        padding: "2px 317px"
      }}>
        OILY WATER TANK
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2931 */}
      <Valve
        className="XV-2931"
        tag="XV_2931"
        x={592}
        y={107}
        isClosed={valves.XV_2931}
        toggle={toggleValve}
      />

      {/* XV-2932 */}
      <Valve
        className="XV-2932"
        tag="XV_2932"
        x={780}
        y={457}
        isClosed={valves.XV_2932}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-2933 */}
      <Valve
        className="XV-2933"
        tag="XV_2933"
        x={672}
        y={410}
        isClosed={valves.XV_2933}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-2934 */}
      <Valve
        className="XV-2934"
        tag="XV_2934"
        x={208}
        y={107}
        isClosed={valves.XV_2934}
        toggle={toggleValve}
      />

      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2931 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2931"
          style={{ position: "absolute", left: 935, top: 535}}  onClick={() => openPanel("FCV_2931")}>
          
          <defs>
            <linearGradient id="metal_2931">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2931)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2931)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2932 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2932"
          style={{ position: "absolute", left: 235, top: 633 }}  onClick={() => openPanel("FCV_2932")}>
          
          <defs>
            <linearGradient id="metal_2932">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2932)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2932)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          
       {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2931?.opening || 0)}
        x={950}
        y={585}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2932?.opening || 0)}
        x={258}
        y={677}
      />


          {/* ================= TRANSMITTER OUTPUTS ================= */}

          
        <Transmitter
          tag="PT-2932"
          value={PT_2932}
          x={170}
          y={206}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED CRUDE OIL FROM SKIM PILE TO OILY WATER TANK"
        />

         <Transmitter
          tag="FIC-2933"
          value={[FIC_2933]}
          x={170}
          y={167}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED CRUDE OIL FROM SKIM PILE TO OILY WATER TANK"
        />

          
        <Transmitter
          tag="PT-2933"
          value={PT_2933}
          x={330}
          y={218}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED CRUDE OIL FROM SUBSEA SETTLEMENT TANK TO OILY WATER TANK"
        />

         <Transmitter
          tag="FIC-2934"
          value={[FIC_2934]}
          x={334}
          y={284}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED CRUDE OIL FROM SUBSEA SETTLEMENT TANK TO OILY WATER TANK"
        />
         <Transmitter
          tag="FIC-2931"
          value={[FIC_2931]}
          x={136}
          y={102}
          unit="LPM"
          max={50}
          HH={48}
          H={45}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED PRODUCED WATER FROM ALL THE DRAINS POINTS TO OILY WATER TANK"
        />
         <Transmitter
          tag="FIC-2932"
          value={[FIC_2932]}
          x={380}
          y={97}
          unit="LPM"
          max={100}
          HH={98}
          H={85}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF RECOVERED PRODUCED WATER FROM VARIOUS CRUDE OUTLET TO OILY WATER TANK"
        />

         <Transmitter
          tag="PT-2931"
          value={PT_2931}
          x={478}
          y={97}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF RECOVERED PRODUCED WATER FROM VARIOUS CRUDE OUTLET TO OILY WATER TANK"
        />
         <Transmitter
          tag="PT-2934"
          value={PT_2934}
          x={565}
          y={168}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF OILY WATER TANK"
        />

        <Transmitter
          tag="FIC-2935"
          value={[FIC_2935]}
          x={897}
          y={72}
          unit="SCF/S"
          max={100}
          HH={98}
          H={85}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF FUEL GAS FROM OILY WATER TANK TO FLARE HEADER"
        />

         <Transmitter
          tag="PT-2935"
          value={PT_2935}
          x={988}
          y={72}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF FUEL GAS FROM OILY WATER TANK TO FLARE HEADER"
        />
         <Transmitter
          tag="PT-2938"
          value={PT_2938}
          x={714}
          y={463}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CRUDE RECOVERED AT SUCTION OF OILY WATER CRUDE PUMPS"
        />

        
        <Transmitter
          tag="FIC-2936"
          value={[FIC_2936]}
          x={150}
          y={635}
          unit="LPM"
          max={100}
          HH={98}
          H={85}
          L={5}
          LL={3}
          c="lime"
          description="FLOWRATE OF CRUDE RECOVERED AT DISCHARGE OF OILY WATER CRUDE PUMPS"
        />

         <Transmitter
          tag="PT-2936"
          value={PT_2936}
          x={368}
          y={635}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF CRUDE RECOVERED AT SUCTION OF OILY WATER CRUDE PUMPS"
        />
        
        <Transmitter
          tag="FIC-2937"
          value={[FIC_2937]}
          x={1080}
          y={549}
          unit="LPM"
          max={20}
          HH={18}
          H={16}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF WATER RECOVERED AT DISCHARGE OF OILY WATER TANK LINE BACK TO SKIM PILE"
        />

         <Transmitter
          tag="PT-2937"
          value={PT_2937}
          x={1160}
          y={549}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF WATER RECOVERED AT DISCHARGE OF OILY WATER TANK LINE BACK TO SKIM PILE"
        />




        
    <Pump
      tag="P-2930A"
      x={504}
      y={513}
      rpm={1800}
      bladeCount={pumpData?.["P-2930A"]?.bladeCount || 3}
      size={pumpData?.["P-2930A"]?.size || 37}
      onClick={openPumpPanel}
    />


    <Pump
      tag="P-2930B"
      x={664}
      y={519}
      rpm={1800}
      bladeCount={pumpData?.["P-2930B"]?.bladeCount || 3}
      size={pumpData?.["P-2930B"]?.size || 37}
      onClick={openPumpPanel}
    />


     <LevelTransmitterIndicator
      tag="LT_2931"
      totalLevel={50000}
      inflows={[(FIC_2932)*0.12]}
      outflows={[FIC_2936]}
      responseFactor={0.05}
      columnX={595}
      columnY={230}
      columnWidth={150}
      columnHeight={125}
      textX={425}
      textY={320}
      showFlow={true}
    />

     <LevelTransmitterIndicator
      tag="LT_2932"
      totalLevel={50000}
      inflows={[(FIC_2932)*0.28]}
      outflows={[FIC_2937]}
      responseFactor={0.05}
      columnX={775}
      columnY={260}
      columnWidth={30}
      columnHeight={165}
      textX={925}
      textY={250}
      showFlow={true}
    />


    




    </div>
  );
}

export default OilyWaterTank;